export default "__VITE_ASSET__Ca9HzyOL__"